import {ProdutoEntity} from "../../pages/_user/produto/produto.entity";


export const AutoCompleteProdutosUotPut = (value: string | number, row: ProdutoEntity) => {
  if (!row) {
    return { nomeProduto: value }
  }
  return { produtoId: row.id }
}
